import { Injectable } from '@angular/core';
import FIngerprintJs from '@fingerprintjs/fingerprintjs';


@Injectable({
  providedIn: 'root'
})
export class FingerprintService {

  public fingerprint: string | null = null;

  public async getFingerprint(): Promise<string>{
    if (this.fingerprint) {
      return this.fingerprint;
    }

    try {
      const fp = await FIngerprintJs.load();
      const result = await fp.get();

      this.fingerprint = result.visitorId;
      return this.fingerprint;
    }
    catch {
      this.fingerprint = '';
      return '';
    }
  }

  public async getDeviceName(): Promise<string>{
    const { UAParser } = await import ('ua-parser-js');

    const result = (new UAParser(navigator.userAgent)).getResult();

    let type = result.device.type? this.capitalize(result.device.type) : 'Desktop';
    let model = result.device.model? result.device.model : result.os.name;

    return `${ type } - ${ model }`;
  }

  protected capitalize(value: string): string{
    if (!value) {
      return '';
    }
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
}
